import { ApiResponse, useFetch } from '@/api/useFetch';
import CONSTANTS from '@/helpers/constants';
import { ApiMethod } from '@/types/enums';

export interface BannerInterface {
  closable: boolean;
  image_desktop: string;
  image_mobile: string;
  link_new_tab: boolean;
  link_url: string;
  reshow_time: number;
  status: boolean;
}

type BannerResponse = {
  ok: boolean;
  result: { panel: BannerInterface; login_register: BannerInterface };
};

const BANNER_URL = CONSTANTS.API_ENTITY_URLS.BANNERS;

export const useGetBanner = async (): Promise<ApiResponse<BannerResponse>> => {
  return useFetch(`skyroom/${BANNER_URL}/info`, {
    method: ApiMethod.Get,
  });
};
